import { render } from "./PageHeader.vue?vue&type=template&id=b86ade70&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=b86ade70&scoped=true&lang=css"

import exportComponent from "/Users/cn7ero/workspace/timemarking/website/www.timemarking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86ade70"]])

export default __exports__